var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 25.2385L23.6345 27.973C23.9628 28.314 24.3815 28.4845 24.8905 28.4845C25.3995 28.4845 25.8245 28.314 26.1655 27.973L32.5 21.6575V24.05C32.5 24.4627 32.6437 24.8075 32.931 25.0845C33.218 25.3615 33.5743 25.5 34 25.5C34.4127 25.5 34.7658 25.3563 35.0595 25.069C35.3532 24.782 35.5 24.4257 35.5 24V18.3075C35.5 17.8052 35.3243 17.3783 34.973 17.027C34.6217 16.6757 34.1948 16.5 33.6925 16.5H27.95C27.5373 16.5 27.1925 16.6468 26.9155 16.9405C26.6385 17.2342 26.5 17.5873 26.5 18C26.5 18.4257 26.6437 18.782 26.931 19.069C27.218 19.3563 27.5743 19.5 28 19.5H30.3425L24.9 25.0115L22.1655 22.277C21.8245 21.9153 21.3995 21.7345 20.8905 21.7345C20.3815 21.7345 19.9628 21.9153 19.6345 22.277L13.746 28.146C13.4487 28.436 13.3 28.7905 13.3 29.2095C13.3 29.6288 13.4487 29.977 13.746 30.254C14.036 30.564 14.3905 30.719 14.8095 30.719C15.2288 30.719 15.577 30.564 15.854 30.254L20.9 25.2385ZM10.6155 41C9.60517 41 8.75 40.65 8.05 39.95C7.35 39.25 7 38.3948 7 37.3845V10.6155C7 9.60517 7.35 8.75 8.05 8.05C8.75 7.35 9.60517 7 10.6155 7H37.3845C38.3948 7 39.25 7.35 39.95 8.05C40.65 8.75 41 9.60517 41 10.6155V37.3845C41 38.3948 40.65 39.25 39.95 39.95C39.25 40.65 38.3948 41 37.3845 41H10.6155Z",
    fill: "#7864F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon_4.17b71e686ebe01f1196b443350cd919f.svg";
export { ForwardRef as ReactComponent };